import { Provider } from 'react-redux'
import { getOrCreateStore } from '@wellesley/store'
import { useWebSocket } from '@wellesley/ws'
import { useAuthTokenWatcher } from '@wellesley/auth'
import { useSentryUser, sentryClient } from '@wellesley/sentry'

import config from './config'
import { useAccountWsUpdate } from '@wellesley/user'
import useUpdateMyProfile from '../common/hooks/useUpdateMyProfile'
import { useGetApiV1InstanceQuery } from '@wellesley/instanceinfo'
import {
  CustomToastContainer,
  SystemToastContainer,
  useNotifications,
} from '@wellesley/notifications'
import { TooltipProvider, useDeviceTypeUpdater } from '@wellesley/ui'

import { useFetchPlatformSettings } from '@wellesley/settings'
import { Router } from './Router'
import { useNetworkStatusListener } from '@wellesley/network'

const { sentry } = config()

sentryClient.init(sentry)

const Hooks = () => {
  useNetworkStatusListener()
  useDeviceTypeUpdater()
  useAuthTokenWatcher()
  useWebSocket()
  useSentryUser()
  useUpdateMyProfile()
  useAccountWsUpdate()
  useNotifications()
  useGetApiV1InstanceQuery()
  useFetchPlatformSettings()

  return null
}

export const App = () => (
  <Provider store={getOrCreateStore()}>
    <Hooks />
    <TooltipProvider>
      <SystemToastContainer />
      <CustomToastContainer />
      <Router />
    </TooltipProvider>
  </Provider>
)
